module.exports = __webpack_public_path__ + "fonts/ARCADECLASSIC.96411199.TTF";